(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/draw-picker.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/draw-picker.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const DatePicker = svs.ui.ReactDatePicker;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const _jotai = jotai,
  useAtom = _jotai.useAtom,
  useAtomValue = _jotai.useAtomValue,
  useSetAtom = _jotai.useSetAtom;
const _ReactDOM = ReactDOM,
  unstable_batchedUpdates = _ReactDOM.unstable_batchedUpdates;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useParams = _ReactRouterDOM.useParams,
  useLocation = _ReactRouterDOM.useLocation;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  selectedResultAtom = _svs$lyckoplatsen$com.selectedResultAtom,
  selectedSpanResultsAtom = _svs$lyckoplatsen$com.selectedSpanResultsAtom,
  shouldShowIntervalAtom = _svs$lyckoplatsen$com.shouldShowIntervalAtom,
  correctionStepAtom = _svs$lyckoplatsen$com.correctionStepAtom;
const _svs$lyckoplatsen$uti = svs.lyckoplatsen.utils.page_result,
  memoFetchNewDates = _svs$lyckoplatsen$uti.memoFetchNewDates,
  formatAvailableDates = _svs$lyckoplatsen$uti.formatAvailableDates,
  memoFetchResult = _svs$lyckoplatsen$uti.memoFetchResult;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.shared_constants.CONSTANTS,
  CORRECTION_STEP = _svs$lyckoplatsen$com2.CORRECTION_STEP,
  RESULT_INTERVALS = _svs$lyckoplatsen$com2.RESULT_INTERVALS;
const productMapping = svs.lyckoplatsen.components.shared_constants.productMapping;
const _dateFns = dateFns,
  format = _dateFns.format,
  getISOWeek = _dateFns.getISOWeek,
  sv = _dateFns.locales.sv;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const DrawPickerTopButtons = svs.lyckoplatsen.components.page_result.react.components.DrawPickerTopButtons;
const INTERVAL_LABEL_BY_DAYS = {
  30: '30 dagar:',
  183: '6 månader:',
  365: '1 år:'
};

const currentActiveDateDraws = jotai.atom({}); 

const DrawPicker = () => {
  const history = useHistory();
  const location = useLocation();
  const _useParams = useParams(),
    dateString = _useParams.dateString;
  const _ref = useAtom(currentActiveDateDraws) || {},
    _ref2 = _slicedToArray(_ref, 2),
    currentDrawPickerDraws = _ref2[0],
    setCurrentActiveDate = _ref2[1]; 

  let initialYear;
  let initialMonth;
  if (dateString && !Object.values(RESULT_INTERVALS).includes(dateString)) {
    var _dateString$split = dateString.split('-');
    var _dateString$split2 = _slicedToArray(_dateString$split, 2);
    initialYear = _dateString$split2[0];
    initialMonth = _dateString$split2[1];
  } else {
    initialYear = dateFns.getYear(new Date());
    initialMonth = dateFns.getMonth(new Date()) + 1;
  }
  const _useAtom = useAtom(selectedResultAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    selectedResult = _useAtom2[0],
    setSelectedResult = _useAtom2[1];
  const spanResults = useAtomValue(selectedSpanResultsAtom);
  const _useAtom3 = useAtom(shouldShowIntervalAtom),
    _useAtom4 = _slicedToArray(_useAtom3, 2),
    shouldShowInterval = _useAtom4[0],
    setShouldShowInterval = _useAtom4[1];
  const setCorrectionStep = useSetAtom(correctionStepAtom);
  const _useState = useState({
      month: initialMonth,
      year: initialYear
    }),
    _useState2 = _slicedToArray(_useState, 2),
    currentMonthYear = _useState2[0],
    setCurrentMonthYear = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  const _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    prevPathname = _useState6[0],
    setPrevPathname = _useState6[1];
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  useEffect(() => {
    (async () => {
      const fetchedDates = await memoFetchNewDates(currentMonthYear.year, currentMonthYear.month);
      if (fetchedDates) {
        unstable_batchedUpdates(() => {
          setCurrentActiveDate(formatAvailableDates(fetchedDates) || {});
        });
      }
    })();
  }, [currentMonthYear, setCurrentActiveDate]);
  const onMonthChange = async _ref3 => {
    let activeStartDate = _ref3.activeStartDate;
    const month = dateFns.getMonth(activeStartDate) + 1;
    const year = dateFns.getYear(activeStartDate);
    setCurrentMonthYear({
      month,
      year
    });
  };
  const updateSelectedResultAndStep = useCallback(result => {
    unstable_batchedUpdates(() => {
      var _svs$lyckoplatsen$dat;
      setShouldShowInterval(false);
      if (!isSelfService && result.drawNumber === ((_svs$lyckoplatsen$dat = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.result_latest.drawNumber)) {
        const startStep = productMapping.isLyckoplatsenPrimary(result.productId) ? CORRECTION_STEP.TOPWIN : CORRECTION_STEP.PLACE;
        setCorrectionStep(startStep);
      } else {
        setCorrectionStep(CORRECTION_STEP.RESULT);
      }
      setSelectedResult(result);
    });
  }, [setShouldShowInterval, setCorrectionStep, setSelectedResult]);
  const handleDateFromUrl = useCallback(async pathname => {
    if (!currentDrawPickerDraws || Object.keys(currentDrawPickerDraws).length === 0) {
      return;
    }
    const match = pathname.match(/\/resultat\/(\d{4}-\d{2}-\d{2})/);
    if (match) {
      const date = new Date(match[1]);
      const draw = Object.values(currentDrawPickerDraws || {}).flatMap(resultDates => resultDates).find(item => dateFns.isSameDay(new Date(item.date), date));
      if (draw) {
        const result = await memoFetchResult(draw.product, draw.drawNumber);
        if (result) {
          unstable_batchedUpdates(() => {
            updateSelectedResultAndStep(result);
          });
        }
      }
    } else {
      unstable_batchedUpdates(() => {
        var _svs$lyckoplatsen$dat2;
        updateSelectedResultAndStep((_svs$lyckoplatsen$dat2 = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat2 === void 0 ? void 0 : _svs$lyckoplatsen$dat2.result_latest);
      });
    }
  }, [currentDrawPickerDraws, updateSelectedResultAndStep]);
  useEffect(() => {
    if ((!prevPathname || prevPathname !== location.pathname) && !shouldShowInterval) {
      handleDateFromUrl(location.pathname);
      setPrevPathname(location.pathname);
    }
  }, [location.pathname, handleDateFromUrl, prevPathname, shouldShowInterval]);
  const onDateChange = async date => {
    handleClose();
    if (!date || !currentDrawPickerDraws || Object.keys(currentDrawPickerDraws).length === 0) {
      return;
    }
    const draw = Object.values(currentDrawPickerDraws || {}).flatMap(resultDates => resultDates).find(item => dateFns.isSameDay(new Date(item.date), new Date(date)));
    if (draw) {
      const result = await memoFetchResult(draw.product, draw.drawNumber);
      if (result) {
        unstable_batchedUpdates(() => {
          updateSelectedResultAndStep(result);
          history.push("/resultat/".concat(dateFns.format(date[0], 'yyyy-MM-dd')));
        });
      }
    }
  };
  const isResultDate = date => Object.values(currentDrawPickerDraws || {}).flatMap(resultDates => resultDates).some(item => dateFns.isSameDay(new Date(item.date), date));
  let selectedDate = new Date((selectedResult === null || selectedResult === void 0 ? void 0 : selectedResult.regCloseTime) || Date.now());
  let externalInputValue = "".concat(format(selectedDate, 'EEEE, d/M', {
    locale: sv
  }), " (v").concat(getISOWeek(selectedDate), ")");
  if (shouldShowInterval) {
    const span = spanResults === null || spanResults === void 0 ? void 0 : spanResults.span;
    if (span !== null && span !== void 0 && span.startDate && span !== null && span !== void 0 && span.endDate) {
      const startDate = new Date(span.startDate);
      const endDate = new Date(span.endDate);
      const days = dateFns.differenceInDays(endDate, startDate);
      const labelPeriod = INTERVAL_LABEL_BY_DAYS[days] || '';
      externalInputValue = "".concat(labelPeriod, " ").concat(dateFns.format(startDate, 'd MMM yyyy').toLowerCase(), " - ").concat(dateFns.format(endDate, 'd MMM yyyy').toLowerCase());
    }
    selectedDate = null;
  }
  return React.createElement("div", {
    className: "lp-draw-picker"
  }, React.createElement(DrawPickerTopButtons, {
    handleClose: handleClose
  }), React.createElement(DatePicker, {
    branding: "tur",
    value: [selectedDate],
    onSet: onDateChange,
    isOpen: isOpen,
    onOpen: handleOpen,
    maxDate: new Date(),
    minDetail: "month",
    externalInputValue: externalInputValue,
    onActiveStartDateChange: onMonthChange,
    tileClassName: _ref4 => {
      let date = _ref4.date;
      return isResultDate(date) ? 'result-date' : null;
    },
    tileDisabled: _ref5 => {
      let date = _ref5.date;
      return !isResultDate(date);
    },
    openWithButton: true,
    popupPosition: "center",
    activeStartDate: new Date(currentMonthYear.year, currentMonthYear.month - 1)
  }), React.createElement("div", {
    className: "lp-draw-picker-overlay ".concat(isOpen ? 'show' : ''),
    onClick: handleClose
  }));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  DrawPicker
});

 })(window);